export type CustomerLegalEntity = {
  legalName: string;
  tradingName: string;
  companyRegistrationNumber: string;
  vatNumber: string;
  taxId: string;
  jurisdictionCountry: string;
  legalEntityType: string;
  incorporationDate: string;
};

export type CustomerContact = {
  contactId: string;
  name: string;
  email: string;
  phoneCountryCode: string;
  phoneNumber: string;
  role: string;
  locationId: string;
  isActive: boolean;
};

export type CustomerTypedLocation = {
  locationId: string;
  type: string;
  line1: string;
  line2: string;
  city: string;
  county: string;
  postalCode: string;
  country: string;
  coordinates: {
    lon: number;
    lat: number;
  };
  isPrimary: boolean;
  isActive: boolean;
};

export type CustomerCorporateHierarchy = {
  parentCustomerId: string;
  ultimateParentCustomerId: string;
  hierarchyLevel: string;
  regionalGrouping: string;
  isGroupAccount: boolean;
};

export type CustomerCommercial = {
  paymentTerms: string;
  creditLimit: string;
  creditCurrency: string;
  contractType: string;
  defaultIncoterms: string;
  pricingTier: string;
};

export type CustomerCompliance = {
  kycStatus: string;
  kycVerifiedAt: string;
  sanctionsCheckStatus: string;
  sanctionsCheckedAt: string;
};

export type CustomerFormValues = {
  customerId: string;
  name: string;
  type: string;
  contactName: string;
  contactEmail: string;
  contactNumber: string;
  hqId?: string;
  hqName?: string;
  address: string;
  country: string;
  postcode: string;
  location: {
    lon: number;
    lat: number;
  };
  operatingHoursFrom: string;
  operatingHoursTo: string;
  notes: string;
  legalEntity: CustomerLegalEntity;
  contacts: CustomerContact[];
  locations: CustomerTypedLocation[];
  corporateHierarchy: CustomerCorporateHierarchy;
  commercial: CustomerCommercial;
  compliance: CustomerCompliance;
  recordType: string;
  market: string;
  channel: string;
  lifecycleStatus: string;
  partnerPayerRef: string;
  partnerBillToRef: string;
  readinessGaps: string;
  hierarchyGroupName: string;
  hierarchyParentName: string;
  hierarchySubNodeName: string;
  hierarchyBanner: string;
  hierarchyBucket: string;
  hierarchyIsShipToSite: boolean;
  hierarchyIsDemandNode: boolean;
};

export const emptyCustomerClassification = {
  recordType: '',
  market: '',
  channel: '',
  lifecycleStatus: '',
  partnerPayerRef: '',
  partnerBillToRef: '',
  readinessGaps: '',
  hierarchyGroupName: '',
  hierarchyParentName: '',
  hierarchySubNodeName: '',
  hierarchyBanner: '',
  hierarchyBucket: '',
  hierarchyIsShipToSite: false,
  hierarchyIsDemandNode: false,
};

export const emptyCustomerLegalEntity: CustomerLegalEntity = {
  legalName: '',
  tradingName: '',
  companyRegistrationNumber: '',
  vatNumber: '',
  taxId: '',
  jurisdictionCountry: '',
  legalEntityType: '',
  incorporationDate: '',
};

export const emptyCustomerContact: CustomerContact = {
  contactId: '',
  name: '',
  email: '',
  phoneCountryCode: '',
  phoneNumber: '',
  role: '',
  locationId: '',
  isActive: true,
};

export const emptyCustomerTypedLocation: CustomerTypedLocation = {
  locationId: '',
  type: '',
  line1: '',
  line2: '',
  city: '',
  county: '',
  postalCode: '',
  country: '',
  coordinates: {
    lon: 0,
    lat: 0,
  },
  isPrimary: false,
  isActive: true,
};

export const emptyCustomerCorporateHierarchy: CustomerCorporateHierarchy = {
  parentCustomerId: '',
  ultimateParentCustomerId: '',
  hierarchyLevel: '',
  regionalGrouping: '',
  isGroupAccount: false,
};

export const emptyCustomerCommercial: CustomerCommercial = {
  paymentTerms: '',
  creditLimit: '',
  creditCurrency: '',
  contractType: '',
  defaultIncoterms: '',
  pricingTier: '',
};

export const emptyCustomerCompliance: CustomerCompliance = {
  kycStatus: '',
  kycVerifiedAt: '',
  sanctionsCheckStatus: '',
  sanctionsCheckedAt: '',
};
